var $7e7ece760f897013$exports = {};
$7e7ece760f897013$exports = {
    "dismiss": `Zru\u{161}i\u{165}`
};


export {$7e7ece760f897013$exports as default};
//# sourceMappingURL=sk-SK.mjs.map
